import Highcharts from "highcharts";

const monochromePalette = ["#111111", "#3f3f46", "#71717a", "#a1a1aa", "#d4d4d8", "#52525b"];

export const createMultiAxisChartOptions = (chartData, startDate) => ({
  chart: {
    zooming: { type: "xy" },
  },
  colors: monochromePalette,
  title: { text: "" },
  xAxis: [{
    type: "datetime",
    crosshair: true,
    labels: {
      formatter: function() {
        return Highcharts.dateFormat("%d", this.value);
      },
      rotation: -45,
      style: {
        fontSize: '12px'
      }
    },
    tickInterval: 24 * 3600 * 1000,
  }],
  yAxis: [
    {
      title: { text: "", style: { color: Highcharts.getOptions().colors[0] } },
      labels: { format: "{value}", style: { color: Highcharts.getOptions().colors[0] } },
    },
    {
      title: { text: "", style: { color: Highcharts.getOptions().colors[1] } },
      labels: { format: "{value} USD", style: { color: Highcharts.getOptions().colors[1] } },
      opposite: true,
    },
  ],
  tooltip: { 
    shared: true,
    formatter: function() {
      const date = Highcharts.dateFormat("%d", this.x);
      let tooltipHTML = `<b>${date}</b><br/>`;
      this.points.forEach(point => {
        tooltipHTML += `${point.series.name}: <b>${point.y}</b>${point.series.name === 'Profit' ? ' USD' : ' calls'}<br/>`;
      });
      return tooltipHTML;
    }
  },
  series: [
    {
      name: "Total Calls",
      type: "column",
      data: chartData.map((item) => [item.x, item.incoming]),
      color: monochromePalette[0],
    },
    {
      name: "Answered Calls",
      type: "line",
      data: chartData.map((item) => [item.x, item.answer]),
      color: monochromePalette[1],
    },
    {
      name: "Missed Calls",
      type: "line",
      data: chartData.map((item) => [item.x, item.miscall]),
      color: monochromePalette[2],
    },
    {
      name: "Cancel Calls",
      type: "line",
      data: chartData.map((item) => [item.x, item.cancelcalls]),
      color: monochromePalette[3],
    },
    {
      name: "Profit",
      type: "line",
      yAxis: 1,
      data: chartData.map((item) => [item.x, item.profit]),
      color: monochromePalette[4],
      marker: { enabled: false },
    },
  ],
  plotOptions: {
    series: {
      pointStart: new Date(startDate).getTime(),
      pointInterval: 24 * 3600 * 1000
    }
  }
});

export const createPieChartOptions = (pieChartData) => ({
  chart: { type: "pie", height: 360 },
  colors: monochromePalette,
  title: { text: "" },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: true,
        style: {
          color: "var(--chart-text-color, #18181b)",
          fontSize: "11px",
          textOutline: "none",
        },
      },
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 640,
        },
        chartOptions: {
          chart: {
            height: 300,
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: false,
              },
            },
          },
        },
      },
    ],
  },
  series: [
    {
      name: "Calls",
      colorByPoint: true,
      data: pieChartData,
    },
  ],
});

export const createTopUsersPieChartOptions = (topUsersData) => ({
  chart: { 
    type: "pie",
    height: '400px'
  },
  colors: monochromePalette,
  title: { 
    text: "",
    style: {
      fontSize: '16px'
    }
  },
//   subtitle: {
//     text: startDate && endDate 
//       ? `Based on total duration in minutes (${startDate} to ${endDate})`
//       : 'No date range selected',
//     style: {
//       fontSize: '12px'
//     }
//   },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.y} minutes</b>'
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        format: '<b>{point.name} :</b> </br> {point.y} min',
        style: {
          color: 'var(--chart-text-color, #18181b)',
          fontSize: '11px',
          textOutline: 'none'
        }
      }
    }
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 640,
        },
        chartOptions: {
          chart: {
            height: 320,
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: false,
              },
            },
          },
        },
      },
    ],
  },
  // series: [{
  //   name: 'Duration',
  //   colorByPoint: true,
  //   data: topUsersData.length > 0 
  //     ? topUsersData 
  //     : [{ name: 'No Data', y: 0, color: '#cccccc' }]
  // }]
 series: [{
    name: 'Duration',
    colorByPoint: true,
    data: topUsersData.length > 0
      ? topUsersData.map((user, index) => ({
          name: user.name,
          y: parseFloat(user.y.toFixed(2)), // Round to two decimal places
          color: monochromePalette[index % monochromePalette.length]
      }))
      : [{ name: 'No Data', y: 0, color: '#cccccc' }]
}]


});
